import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToursService } from '../services/tours.service';

@Injectable({
  providedIn: 'root'
})
export class TourModeGuard implements CanActivate {
  constructor(
    private toursService: ToursService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isInTourMode = this.toursService.isInTourMode();
    const url = state.url;

    // Allow access to tour pages when in tour mode
    if (url.startsWith('/tours')) {
      return true;
    }

    // Block access to other pages when in tour mode
    if (isInTourMode) {
      // Redirect to active tour page
      return this.router.createUrlTree(['/tours/active']);
    }

    // Allow normal navigation when not in tour mode
    return true;
  }
}
